<template>
<div class="create-company">

  <vue-headful
    title="TZ Design Box - Create Company"
    description="TZ Design Box"
/>

  <div class="container">
    <div class="columns">
      <div class="column is-2 menu-vert">
        <MenuVert :currentactive="'create-company'" />
      </div>
      <div class="column is-10" style="margin-top:25px;">
        <Breadcrumbs/>
        <hr>
        <div class="content">
          <h2>{{ $t("create-company") }}</h2>
          <p>{{ $t("company-create-details") }}</p>
          <form @submit.prevent="validateBeforeSubmit">
            <b-field grouped>
              <b-field expanded :label="$t('name-company')"
                :type="{'is-danger': errors.has('name1')}"
                :message="errors.first('name1')">
                <b-input v-model="company.name1" name="name1" v-validate="'required'" />
              </b-field>
              <b-field expanded :label="$t('name2')"
                :type="{'is-danger': errors.has('name2')}"
                :message="errors.first('name2')">
                <b-input v-model="company.name2" name="name2" />
              </b-field>
            </b-field>

            <b-field :label="$t('tax-number')"
              :type="{'is-danger': errors.has('vat_number')}"
              :message="errors.first('vat_number')">
              <b-input v-model="company.vat_number" name="vat_number"/>
            </b-field>

            <b-field grouped>
              <b-field expanded :label="$t('address1')"
                :type="{'is-danger': errors.has('address1')}"
                :message="errors.first('address1')">
                <b-input v-model="company.address1" name="address1" v-validate="'required'" />
              </b-field>
              <b-field expanded :label="$t('address2')"
                :type="{'is-danger': errors.has('address2')}"
                :message="errors.first('address2')">
                <b-input v-model="company.address2" name="address2" />
              </b-field>
            </b-field>

            <b-field grouped>
              <b-field :label="$t('zip')"
                :type="{'is-danger': errors.has('zip')}"
                :message="errors.first('zip')">
                <b-input v-model="company.zip" name="zip" v-validate="'required'" />
              </b-field>

              <b-field expanded :label="$t('city')"
                :type="{'is-danger': errors.has('city')}"
                :message="errors.first('city')">
                <b-input v-model="company.city" name="city" v-validate="'required'" />
              </b-field>

              <b-field :label="$t('country')"
                  :type="{'is-danger': errors.has('country')}"
                  :message="errors.first('country')">
                  <b-select  name="country"
				             v-model="company.country"
							 :placeholder="$t('choice')"
							 value="AT"
							 v-validate="'required'">
                    <option
                        v-for="country in getCurrentCompany.country_choices"
                        :value="country[0]"
                        :key="country[0]">
                        {{ country[1] }}
                    </option>
                  </b-select>
              </b-field>
            </b-field>

            <b-field grouped>
              <b-field :label="$t('region')">
              <b-select v-if="getCurrentCompany.region_default!==null"
                     	v-model="company.region"
                     	:disabled="getCurrentCompany.region_choices.length <= 1"
                     >
                <option
                      v-for="region in getCurrentCompany.region_choices"
                      :value="region[0]"
                      :key="region[0]">
                      {{ region[1] }}
                </option>
              </b-select>
              </b-field>

              <b-field :label="$t('discount-group')">
              <b-select v-if="getCurrentCompany.discount_group_default!==null"
                      	v-model="company.discount_group"
                     	:disabled="getCurrentCompany.discount_group_choices.length <= 1"
                     >
                <option
                      v-for="discount in getCurrentCompany.discount_group_choices"
                      :value="discount[0]"
                      :key="discount[0]">
                      {{ discount[1] }}
                  </option>
              </b-select>
              </b-field>

              <b-field :label="$t('assortment')">
              <b-select v-if="getCurrentCompany.assortment_default!==null"
                        v-model="company.assortment"
                        :disabled="getCurrentCompany.assortment_choices.length <= 1"
                       >
                    <option
                      v-for="assortment in getCurrentCompany.assortment_choices"
                      :value="assortment[0]"
                      :key="assortment[0]">
                      {{ assortment[1] }}
                  </option>
              </b-select>
              </b-field>


              <b-field :label="$t('language')">
              <b-select v-if="getCurrentCompany.language!==null"
                        v-model="company.language">
				<option
                      v-for="language in getCurrentCompany.language_choices"
                      :value="language[0]"
                      :key="language[0]">
                      {{ language[1] }}
                  </option>
              </b-select>
              </b-field>
            </b-field>

            <b-field :label="$t('lines')">
              <b-select multiple native-size="3"
			      v-model="getCurrentCompany.lines"
				  v-if="getCurrentCompany.line_default!==null"
				  :value="getCurrentCompany.line_default">
                <option
                  v-for="line in getCurrentCompany.line_choices"
                  :value="line[0]"
                  :key="line[0]">
                    {{ line[1] }}
                </option>
              </b-select>
            </b-field>

            <b-button native-type="submit" type="is-primary" :loading="saveCompanyActive">{{ $t("save") }}</b-button>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import MenuVert       from '@/components/MenuVert'
import Breadcrumbs    from '@/components/Breadcrumbs'
import { mapGetters } from 'vuex'

export default{
    name:'CreateCompany',
    computed: {
        ...mapGetters (["getCurrentCompany","saveCompanyActive","getCompany"])
    },
    data: function () {
		return {
			company: {
				country: undefined,
				region: undefined,
				assortment: undefined,
				discount_group: undefined,
				assortment: undefined,
				language: undefined
			}
		}
	},
    components: {MenuVert, Breadcrumbs},
    methods: {
        validateBeforeSubmit() {
            var self=this
            this.$validator.validateAll().then((result) => {
                if (result) {
                    this.$store.dispatch("createCompany",{company:this.company,cid:this.getCompany,self:self})
                    .catch((error) =>{
                        self.$toastr('error', error, 'Failure');
                    });
                    return;
                }
            });
        },
    },
	watch : {
		getCurrentCompany (value) {
			let defaults = ["region", "discount_group", "assortment"]
			if (this.company.country === undefined)
				this.company.country = value.country [0]
			for (let i = 0; i < defaults.length; i++) {
				let attr = defaults [i]
				let def_attr = attr + "_default"
				if (this.company [attr] === undefined) {
					this.company [attr] = value [def_attr] [0]
				}
			}
		}
	},
    created(){
        let self = this
        this.$store.dispatch("callCurrentCompany",{self:self,company:this.getCompany})
    }
}
</script>

<style>
label {
  width: 100% !important
}

.create-company{
    padding-bottom:50px;
}
.content{
    background-color:#fff!important;
    padding:25px;
    box-shadow: 0 1px #FFFFFF inset, 0 1px 3px rgba(34, 25, 25, 0.4);
}
</style>
